import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboardpage',
  templateUrl: './dashboardpage.component.html'
})
export class DashboardPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


}
